import { AiPromptsLibraryAdapter } from './ai-prompts-library.adapter';

export class AiPromptsLibraryService extends AiPromptsLibraryAdapter {}
